import { call, put, takeLatest, select } from 'redux-saga/effects';
import { delay } from 'redux-saga'


import {
    GET_CINEMA_FILTERS,
    GET_GENRE_FILTERS,
    GET_STATUS_FILTERS,
    GET_TYPE_FILTERS,
    GET_CINEMA_LOCATIONS,
    STORE_CINEMA_LOCATION,
    GET_DISTRIBUTORS,
    GET_STUDIOS,
    STORE_SELECTED_FESTIVAL_DATE,
    STORE_SELECTED_EVENT_LOCATION,
    STORE_SELECTED_MOVIE_FILTERS,
    STORE_SELECTED_MOVIES_SORT_BY,
    GET_SOON_IN_CINEMA_FILTERS,
    GET_BOX_OFFICE_GENRE_FILTERS,
    STORE_SELECTED_HOUR,
    STORE_SELECTED_DATE,
    REDIRECT_URL,
} from "../actions/types";

import { showGeneralError, hideGeneralError } from '../actions/general.actions';
import { GENERIC_ERROR_MESSAGE } from "../config/messages";

import {
    getGenreFilters,
    getStatusFilters,
    getTypeFilters,
    getCinemaFilters,
    getCinemaLocations,
    getSoonInCinemaFilters,
    getBoxOfficeGenreFilters
} from "../api/filters.api";

import {
    getGenreFiltersSucceeded,
    getStatusFiltersSucceeded,
    getTypeFiltersSucceeded,
    getCinemaFiltersSucceeded,
    getCinemaLocationsSucceeded,
    storeSelectedCinemaLocationSucceeded,
    getSoonInCinemaFiltersSucceeded,
    storeSelectedFestivalDateSucceeded,
    storeSelectedEventLocationSucceeded,
    storeSelectedMovieFiltersSucceeded, 
    storeSelectedMoviesSortBySucceeded,
    getBoxOfficeGenreFiltersSucceeded,
    storeSelectedHourSucceeded, 
    storeSelectedDateSucceeded, 
    redirectUrlSucceeded
} from "../actions/filters.actions";

import { showSpinner, hideSpinner } from '../actions/loading.actions';
import { getSoonInCinemaFilteredMovies } from "../api/movies.api";
import { getSoonInCinemaFilteredMoviesSucceeded } from "../actions/movies.actions";


function* getGenreFiltersSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(getGenreFilters, action.payload);
        if (response.status) {
            yield put(hideSpinner());
        }
        if (response.status === 200) {
            yield put(getGenreFiltersSucceeded(response.data));
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* getStatusFiltersSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(getStatusFilters, action.payload);
        if (response.status) {
            yield put(hideSpinner());
        }
        if (response.status === 200) {
            yield put(getStatusFiltersSucceeded(response.data));
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* getTypeFiltersSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(getTypeFilters, action.payload);
        if (response.status) {
            yield put(hideSpinner());
        }
        if (response.status === 200) {
            yield put(getTypeFiltersSucceeded(response.data));
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* getCinemaFiltersSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(getCinemaFilters, action.payload);
        if (response.status) {
            yield put(hideSpinner());
        }
        if (response.status === 200) {
            yield put(getCinemaFiltersSucceeded(response.data));
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* getDistributors(action) {
    // try {
    //     yield put(showSpinner());
    //     const response = yield call(getDistributorsFromAPI, action.payload);
    //     if (response.status) {
    //         yield put(hideSpinner());
    //     }
    //     if (response.status === 200) {
    //         yield put(getDistributorsSucceeded(response.data));
    //     }
    // } catch (e) {
    //     yield put(hideSpinner());
    //     yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
    //     yield call(delay, 5000);
    //     yield put(hideGeneralError(''));
    // }
}

function* getStudios(action) {
    // try {
    //     yield put(showSpinner());
    //     const response = yield call(getStudiosFromAPI, action.payload);
    //     if (response.status) {
    //         yield put(hideSpinner());
    //     }
    //     if (response.status === 200) {
    //         yield put(getStudiosSucceeded(response.data));
    //     }
    // } catch (e) {
    //     yield put(hideSpinner());
    //     yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
    //     yield call(delay, 5000);
    //     yield put(hideGeneralError(''));
    // }
}

function* getCinemaLocationsSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(getCinemaLocations, action.payload);
        if (response.status) {
            yield put(hideSpinner());
        }
        if (response.status === 200) {
            yield put(getCinemaLocationsSucceeded(response.data));
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* storeCinemaLocationSaga(action) {
    try {
        localStorage.setItem('cinema_location', action.payload);
        yield put(storeSelectedCinemaLocationSucceeded(action.payload));
    } catch (e) {
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}


function* storeSelectedFestivalDateSaga(action) {
    try {
        const prevState = yield select(state => state.filters.festival_details_filters);
        const selectedFilters = { ...prevState, selected_festival_date: action.payload }
        yield put(storeSelectedFestivalDateSucceeded(selectedFilters));
    } catch (e) {
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* storeSelectedEventLocationSaga(action) {
    try {
        const prevState = yield select(state => state.filters.festival_details_filters);
        const selectedFilters = { ...prevState, selected_event_location: action.payload }
        yield put(storeSelectedEventLocationSucceeded(selectedFilters));
    } catch (e) {
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* storeSelectedMovieFiltersSaga(action) {
    try {
        const prevState = yield select(state => state.filters.movies_filters)
        const selectedFilters = { ...prevState, selected_filters: action.payload }
        yield put(storeSelectedMovieFiltersSucceeded(selectedFilters));
    } catch (e) {
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* storeSelectedMoviesSortBySaga(action) {
    try {
        const prevState = yield select(state => state.filters.movies_filters)
        const selectedFilters = { ...prevState, selected_sortBy: action.payload }
        yield put(storeSelectedMoviesSortBySucceeded(selectedFilters))
    } catch (e) {
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* getSoonInCinemaFiltersSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(getSoonInCinemaFilters, action.payload);

        if (response.status === 200) {
            yield put(getSoonInCinemaFiltersSucceeded(response.data));

            //get initial movies for first filter
            const resp = yield call(getSoonInCinemaFilteredMovies, response.data[0]['film_release_months'][0]['film_release_month_short']);

            if (resp.status) {
                yield put(hideSpinner());
            }
            if (resp.status === 200) {
                const dada = {
                    current_date: response.data[0]['film_release_months'][0]['film_release_month_short'],
                    resp: resp.data
                }
                yield put(getSoonInCinemaFilteredMoviesSucceeded(dada));
            }

        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* getBoxOfficeGenreFiltersSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(getBoxOfficeGenreFilters, action.payload);

        if (response.status) {
            yield put(hideSpinner());
        }
        if (response.status === 200) {
            yield put(getBoxOfficeGenreFiltersSucceeded(response.data));
        }
    }
    catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* storeSelectedHourSaga(action) {
    try {
        yield put(storeSelectedHourSucceeded(action.payload))
    } catch (e) {
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* storeSelectedDateSaga(action) {
    try {
        yield put(storeSelectedDateSucceeded(action.payload))
    } catch (e) {
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* redirectUrlSaga(action) {
    try {
        yield put(redirectUrlSucceeded(action.payload));
    } catch(e){
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

export default function* filtersSaga() {
    yield takeLatest(GET_GENRE_FILTERS, getGenreFiltersSaga);
    yield takeLatest(GET_STATUS_FILTERS, getStatusFiltersSaga);
    yield takeLatest(GET_TYPE_FILTERS, getTypeFiltersSaga);
    yield takeLatest(GET_CINEMA_FILTERS, getCinemaFiltersSaga);
    yield takeLatest(GET_DISTRIBUTORS, getDistributors);
    yield takeLatest(GET_STUDIOS, getStudios);
    yield takeLatest(GET_CINEMA_LOCATIONS, getCinemaLocationsSaga);
    yield takeLatest(STORE_CINEMA_LOCATION, storeCinemaLocationSaga);
    yield takeLatest(STORE_SELECTED_FESTIVAL_DATE, storeSelectedFestivalDateSaga);
    yield takeLatest(STORE_SELECTED_EVENT_LOCATION, storeSelectedEventLocationSaga);
    yield takeLatest(STORE_SELECTED_MOVIE_FILTERS, storeSelectedMovieFiltersSaga);
    yield takeLatest(STORE_SELECTED_MOVIES_SORT_BY, storeSelectedMoviesSortBySaga);
    yield takeLatest(GET_SOON_IN_CINEMA_FILTERS, getSoonInCinemaFiltersSaga);
    yield takeLatest(GET_BOX_OFFICE_GENRE_FILTERS, getBoxOfficeGenreFiltersSaga);
    yield takeLatest(STORE_SELECTED_HOUR, storeSelectedHourSaga);
    yield takeLatest(STORE_SELECTED_DATE, storeSelectedDateSaga);
    yield takeLatest(REDIRECT_URL, redirectUrlSaga);
}




// WEBPACK FOOTER //
// ./src/SHARED/sagas/filters.saga.js